import React from 'react';
import { Row } from 'react-bootstrap';
import { FormFilterCard, FieldDateRanger, buildWhereForDates, FormCol } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectMaterial } from 'shared-pages/components';

export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  console.log('VALUES', values);

  if (values) {
    if (values.materialId) {
      where = { ...where, materialId: values.materialId };
    }
    if (values.startDate || values.endDate) {
      console.log('startDate', values.startDate, 'endDate', values.endDate);
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateCollected'),
      };
    }
  }
  return JSON.stringify(where);
}

export const Filters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    onChange(values);
    setSubmitting(false);
  }
  const filters = {
    materialId: initialValues?.materialId ?? '',
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
  };
  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      enableReinitialize={true}
    >
      <Row style={{ marginBottom: '1rem', gap: '1rem' }}>
        <FieldSelectMaterial as={FormCol} label="Απόβλητο" name="materialId" required />
        <FieldDateRanger as={FormCol} label={t('Από')} name="startDate" name2="endDate" />
      </Row>
    </FormFilterCard>
  );
};
